'use strict';

window.mecCo = {
  breakpoint: 720
};

// modules
require('./_modules/openDrawer');
require('./_modules/scroll');
require('./_modules/slider');
require('./_modules/accordion');
require('./_modules/expandNav');

$('.js-drawer').each(function(){
  new OpenDrawer(this, {bp: window.mecCo.breakpoint});
});

$('.js-scroll-btn').each(function(){
  new Scroll(this, {
    stopEl: $(this).data('stop'),
    isHidden: $(this).data('hidden')
  });
});

$('.l-header-pcnav_L3Link').on('touchstart',function(){
  var url = $(this).attr("href");
  location.href = url;
});

$('.js-Slider').each(function(){
  new Slider(this, {bp: window.mecCo.breakpoint});
});

$('.js-Accordion').each(function(){
  new Accordion(this, {parent: true});
});

$('.js-ExpandNav').each(function(){
  new ExpandNav(this, {bp: window.mecCo.breakpoint});
});

$('.js-mecInfo_navTab li').click(function(){
  var tab_id = $(this).attr('data-tab');
  $('.js-mecInfo_navTab li').removeClass('current');
  $('.js-infoTopics_Content').removeClass('current');
  $(this).addClass('current');
  $("#"+tab_id).addClass('current');
});

$('.js-faq_Content').on('click', function(){
  var answer = $(this).next();
  if($(this).hasClass('p-faq_active')) {
    var itemHeight = answer.height();
    answer.animate({
      marginTop: "-"+itemHeight+"px",
    },500);
  } else {
    answer.show();
    answer.animate({
      marginTop: 0,
    }, 500);
  }
  $(this).toggleClass('p-faq_active');
});
$('.js-faq_Answer').hide(0,function(){
  var content = $(this).prev();
  var answer = $(this);
  var itemHeight = answer.height();
  answer.animate({
    marginTop: "-"+itemHeight+"px",
  },10);
  content.toggleClass('p-faq_active');
});

(function ($) {
  $.fn.extend({
    openPopup: function (options) {
      var defaults = {}
      var options = $.extend(defaults, options);
      return this.each(function () {
        var obj = $(this);
        //open popup
        obj.click(function () {
          var idPopup = $(this).attr('data-popup');
          if (idPopup != '#') {
            if (idPopup.length >= 1) {
              if (!$(idPopup).hasClass('is-Active_Item')) {
                $(idPopup).addClass('is-Active_Item');
                $(idPopup).parent().addClass('is-Active_Popup');
              }
            }
          }
        });
        //close popup
        var btnClosePopup = $('.js-ClosePopup');
        if (btnClosePopup.length >= 1) {
          btnClosePopup.click(function () {
            var boxPopupContent = $(this).parents('.is-Active_Popup');
            boxPopupContent.removeClass('is-Active_Popup').find('.is-Active_Item').removeClass('is-Active_Item');
          });
        }
      });
    }
  });

})(jQuery);

$('.js-eSchoolCourse_Popup_Open,.js-popup_open').openPopup();



//////////////////
// WEBPACK FOOTER
// ./js/common.js
// module id = 0
// module chunks = 0